/**
 * College Cost Calculator
 */
function calculate(vals) {
  "use strict";
  $.ajax({
    type: "POST",
    url: "/wp-admin/admin-ajax.php",
    data: {action:'fw_college_calculator',vals:vals},
    dataType: "html",
    success: function (data) {
      $(".editable-form").html(data);
      $("select").select2();
      $(".currency").autoNumeric("init", {
        aSign: "$",
        mDec: 0,
        currencySymbolPlacement: "p",
      });
      window.scrollTo(0, 270);
    },
    error: function (data) {
      console.log(data);
    },
  });
}

$(document).on("ready", function () {
  if ($(".college-cost-calculator").length) {
    $("#college-cost-calculator").on("focusin", "input.currency", function () {
      if (parseInt($(this).val()) === 0 || $(this).val() === typeof undefined || $(this).val() === "") $(this).val("");
    });
    $("#college-cost-calculator").on("focusout", "input.currency", function () {
      if (parseInt($(this).val()) === 0 || $(this).val() === typeof undefined || $(this).val() === "") $(this).val(0);
    });
    $(document).on("click", "#my-colleges", function (e) {
      e.preventDefault();
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        data:{action:'fw_my_colleges'},
        success: function (data) {
          addOverlay("my-colleges", data);
          $("#overlay .add span").off("click");
          $("#overlay").on("click", ".add span", function () {
            var $add = $(this);
            calculate({
              do_action: "add",
              SchoolID: $add.attr("id"),
            });
            $("#overlay").remove();
          });
        },
        error: function () {},
      });
    });
    $(document).on("click", ".college-cost-calculator #my-plans", function (e) {
      e.preventDefault();
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        data:{action:'fw_my_masstransfer_plans_ajax'},
        success: function (data) {
          addOverlay("my-colleges", data);
          $("#overlay .add span").off("click");
          $("#overlay").on("click", ".add span", function () {
            var $add = $(this);
            calculate({
              do_action: "add-plan",
              PlanID: $add.attr("id"),
            });
            $("#overlay").remove();
          });
        },
        error: function () {},
      });
    });
    $(document).on("click", "#browse-colleges", function (e) {
      e.preventDefault();
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        data:{action:"fw_all_colleges"},
        success: function (data) {
          addOverlay("all-colleges", data);
          $("#overlay li").on("click", function () {
            var which = $(this).attr("data-which");
            $(".tab, #overlay li").removeClass("active");
            $(this).addClass("active");
            $("#tab" + which).addClass("active");
          });
          $(".tab a").on("click", function (e) {
            e.preventDefault();
            var $add = $(this);
            calculate({
              action: "add",
              SchoolID: $add.attr("data-id"),
            });
            $("#overlay").remove();
          });
        },
        error: function () {},
      });
    });
    $(document).on("change", "#selectCollege", function () {
      var val = $(this).val();
      var text = $("#selectCollege option:selected").text();
      calculate({
        do_action: "add",
        SchoolID: val,
      });
      $("#overlay").remove();
    });
    // END SELECT COLLEGE
    $(document).on("click", ".formFooter .primary", function (e) {
      e.preventDefault();
      if ($(this).hasClass("disabled")) {
        return;
      }
      calculate($("#college-cost-calculator").serialize());
    });
    $(document).on("change", "#fees input", function () {
      var fees = 0;
      $("#fees input").each(function () {
        if ($(this).attr("id") != "tcpy") {
          if ($(this).val() === "" || !$(this).hasClass("currency")) return;
          var v = parseInt($(this).val().replace(/\D/g, ""));
          fees = fees + v;
        }
      });
      $("#tcpy").autoNumeric("set", fees);
    });
    $(document).on("change", "#awards input", function () {
      var fees = 0;
      $("#awards input:not(#factor-savings)").each(function () {
        if ($(this).attr("id") != "tapy" && $(this).attr("id") != "otherResources" && $(this).attr("id") != "privateScholarships") {
          console.log($(this).val());
          if ($(this).val() === "" || !$(this).hasClass("currency")) return;
          fees = fees + parseInt($(this).val().replace(/\D/g, ""));
        }
      });
      $("#tapy").autoNumeric("set", fees);
    });
    $(document).on("click", ".head:not(.yearly) th", function () {
      $(this).closest("tbody").toggleClass("closed");
    });
    $(document).on("click", ".remove", function () {
      var id = $(this).attr("data-id");
      if ($(this).hasClass("plan")) {
        calculate({
          do_action: "remove",
          PlanID: id,
        });
      } else {
        calculate({
          do_action: "remove",
          SchoolID: id,
        });
      }
    });
    $(document).on("click", ".edit", function () {
      var id = $(this).attr("data-id");
      calculate({
        do_action: "edit",
        SchoolID: id,
      });
    });
    $(document).on("click", "th .btn.primary", function () {
      //var id=$(this).attr('data-id');
      calculate({
        do_action: "add",
      });
    });
    $(document).on("click", "#addSchol", function (e) {
      e.preventDefault();
      var i = $(".otherSchol input.currency").length;
      $(".otherSchol span").append(
        '<input type="text" aria-label="OP Scholarship Name" name="opSchol[' +
          i +
          '][Name]" placeholder="Name" /><input type="text" name="opSchol[' +
          i +
          '][Value]" value="" id="" aria-label="OP Scholarship Value" class="currency opSchol" placeholder="$0" />'
      );
      $(".otherSchol span .currency").autoNumeric("init", {
        aSign: "$",
        mDec: 0,
        currencySymbolPlacement: "p",
      });
    });
    $(document).on("change", $(".otherSchol .currency"), function () {
      var val = 0;
      $(".otherSchol")
        .find(".currency")
        .each(function (i, n) {
          if ($(n).val() === "") return;
          val += parseInt($(n).val().replace(/\D/g, ""), 10);
        });
      $("#privateScholarships").autoNumeric("set", val);
    });
    $(document).on("click", "#addResource", function (e) {
      e.preventDefault();
      var i = $(".otherResources input.currency").length;
      $(".otherResources span").append(
        '<input type="text" aria-label="Other Resource Name" name="oRes[' +
          i +
          '][Name]" placeholder="Name" /><input type="text" name="oRes[' +
          i +
          '][Value]" value="" id="" aria-label="Other Resource Value" class="currency oRes" placeholder="$0" />'
      );
      $(".otherResources span .currency").autoNumeric("init", {
        aSign: "$",
        mDec: 0,
        currencySymbolPlacement: "p",
      });
    });
    $(document).on("change", $(".otherResources .currency"), function () {
      var val = 0;
      $(".otherResources")
        .find(".currency")
        .each(function (i, n) {
          if ($(n).val() === "") return;
          val += parseInt($(n).val().replace(/\D/g, ""), 10);
        });
      $("#otherResources").autoNumeric("set", val);
    });
    $(document).on("change", $("#factor-savings"), function () {
      $("td.cc-ecp").each(function () {
        if ($("#factor-savings").prop("checked")) {
          var val = $(this).data("value");
        } else {
          var val = 0;
        }
        var which = $(this).data("which");
        var newVal = parseInt($("." + which).data("value")) - parseInt(val);
        $("." + which).attr("data-value", newVal);
        $(".yearly .currency." + which)
          .html(newVal)
          .autoNumeric("init", {
            aSign: "$",
            mDec: 0,
            currencySymbolPlacement: "p",
          });
        $(".yearly .currency." + which).autoNumeric("set", newVal);
        $(".total .currency." + which)
          .html(newVal * 4)
          .autoNumeric("init", {
            aSign: "$",
            mDec: 0,
            currencySymbolPlacement: "p",
          });
        $(".total .currency." + which).autoNumeric("set", newVal * 4);
      });
    });
  } // END COLLEGE COST CALCULATOR
});
